export default __webpack_public_path__ + "static/media/sadEmotionFaceEmoji.560cdfec.svg";